import SectionLabel from "@/components/base/SectionLabel";
import { aboutLabData } from "@/mocks/aboutData";

export default function AboutNobleLaboSection() {
  return (
    <section id="about-lab" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="reveal max-w-3xl mx-auto mb-12 md:mb-16 text-center">
          <SectionLabel label={aboutLabData.label} className="mb-3" />
          <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-900 mb-5 md:mb-6">
            {aboutLabData.heading}
          </h2>
          <div className="space-y-3 md:space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed text-left">
            {aboutLabData.paragraphs.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>

        <div className="reveal max-w-4xl mx-auto">
          <div className="relative px-0">
            {/* Connected flow: horizontal on desktop, vertical on mobile */}
            <div className="hidden md:flex items-start justify-between gap-0">
              {aboutLabData.flowSteps.map((step, idx) => (
                <div key={idx} className="flex flex-col items-center flex-1 relative">
                  {/* Connector line from previous */}
                  {idx > 0 && (
                    <div className="absolute top-6 left-0 right-1/2 h-[2px] bg-gradient-to-r from-primary-200/40 via-primary-300/60 to-primary-400/40" />
                  )}
                  {idx < aboutLabData.flowSteps.length - 1 && (
                    <div className="absolute top-6 left-1/2 right-0 h-[2px] bg-gradient-to-r from-primary-400/40 via-primary-300/60 to-primary-200/40" />
                  )}

                  {/* Step circle */}
                  <div className="relative z-10 w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center mb-3">
                    <i className={`${step.icon} text-lg text-background-50`} />
                  </div>

                  {/* Step label */}
                  <span className="text-xs md:text-sm font-medium text-foreground-800 text-center leading-snug max-w-[100px]">
                    {step.label}
                  </span>
                </div>
              ))}
            </div>

            {/* Mobile vertical flow */}
            <div className="flex md:hidden flex-col items-start gap-0">
              {aboutLabData.flowSteps.map((step, idx) => (
                <div key={idx} className="flex items-center gap-4 relative">
                  {/* Vertical connector */}
                  {idx < aboutLabData.flowSteps.length - 1 && (
                    <div className="absolute top-10 left-5 w-[2px] h-8 bg-gradient-to-b from-primary-300/60 to-primary-200/30" />
                  )}

                  <div className="relative z-10 w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-base text-background-50`} />
                  </div>
                  <span className="text-sm font-medium text-foreground-800 leading-snug">
                    {step.label}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}